import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { toast } from 'sonner';
import { Save } from 'lucide-react';

const ArchivesManager = () => {
  const [fields, setFields] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/admin/archives/about')
      .then(({ data }) => setFields(data.fields))
      .catch(() => toast.error('Erreur de chargement'));
  }, []);

  const update = (idx, text) => setFields((p) => p.map((f, i) => (i === idx ? { ...f, text } : f)));

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/admin/archives/about', { fields });
      toast.success('Archive enregistrée');
    } catch { toast.error('Erreur'); }
    finally { setSaving(false); }
  };

  if (!fields) return <p className="text-center text-[#6B6B6B] py-20">Chargement…</p>;

  return (
    <div data-testid="admin-archives-manager">
      <div className="flex flex-col md:flex-row justify-between md:items-end gap-6 mb-10">
        <div>
          <span className="text-xs uppercase tracking-[0.4em] text-[#111111] mb-2 block">Non publié</span>
          <h2 className="text-4xl font-serif text-[#111111]">Archives — ancienne section À propos</h2>
          <p className="text-sm text-[#6B6B6B] mt-3 max-w-2xl leading-relaxed">
            Textes de l'ancienne section « À propos » de l'accueil (avant la refonte). Ils ne sont affichés nulle part sur le site public
            et sont conservés ici pour de futures décisions éditoriales. La photo d'origine se trouve dans Photos du site → Archives.
          </p>
        </div>
        <button onClick={save} disabled={saving} data-testid="archives-save" className="inline-flex items-center gap-2 px-6 py-3 text-xs uppercase tracking-[0.3em] bg-[#111111] text-white hover:bg-[#333333] transition-colors disabled:opacity-50">
          <Save className="w-4 h-4" /> {saving ? 'Enregistrement…' : 'Enregistrer'}
        </button>
      </div>
      <div className="space-y-6 max-w-3xl">
        {fields.map((f, i) => (
          <label key={f.label} className="block">
            <span className="text-[10px] uppercase tracking-[0.3em] text-[#6B6B6B] mb-2 block">{f.label}</span>
            <textarea value={f.text} onChange={(e) => update(i, e.target.value)} rows={f.text.length > 120 ? 4 : 2} className="luxury-input-light" data-testid={`archive-field-${i}`} />
          </label>
        ))}
      </div>
    </div>
  );
};

export default ArchivesManager;
